import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import env from './env.json'

// ================== CAMBIO 1: Imports Añadidos ==================
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
// ================================================================

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Menu from './components/Menu';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import Survey from './pages/Survey';
import FAQ from './pages/FAQ';
import Login from './pages/Login';
import Location from './pages/Location';
import Services from './pages/Services';
import ButtonSos3 from './pages/ButtonSos3';
import Logout from './pages/Logout';
import Terms from './pages/Terms';
import SOS from './pages/SOS';
import PQRS from './pages/PQRS'; 
import CreateTicket from './pages/CreateTicket';
import TicketDetail from './pages/TicketDetail';
import DoSurvey from './pages/DoSurvey';
import Cotizar from './pages/Cotizar';
import ResetPassword from './pages/ResetPassword';
import React, { useState } from 'react';
import { Network } from '@ionic-native/network';
import News from './pages/News';
import ReactGA from "react-ga4";
import axios from 'axios';

setupIonicReact();

const App: React.FC = () => {

  // ================== CAMBIO 2: Lógica del StatusBar Añadida ==================
  useEffect(() => {
    // Esta función se ejecutará una sola vez cuando la app se inicie
    const configureStatusBar = async () => {
      // Solo se ejecuta en plataformas nativas (iOS/Android), no en el navegador web
      if (Capacitor.isNativePlatform()) {
        await StatusBar.setOverlaysWebView({ overlay: false });
        //await StatusBar.setBackgroundColor({ color: '#0d47a1' }); // <-- ¡IMPORTANTE! Usa tu color exacto aquí
        await StatusBar.setStyle({ style: Style.Light });
      }
    };

    configureStatusBar();
  }, []); // El array vacío [] asegura que solo se ejecute una vez.
  // ===========================================================================


  const user = localStorage.getItem('profile') as string;
  const profile = user ? JSON.parse(user) : null;

  const userId = profile?.id ?? ''; 
  console.log(userId); 

  const logPageView = (id: string) => {
    if (id) {
      ReactGA.set({ id });
    }
  };

  React.useEffect(() => {
    if (userId) logPageView(userId);
  }, [userId]);

  let session = localStorage.getItem('token');
  const url = env.REACT_APP_URL;
  const [netState, setNetState] = useState(true);

  const sos = async () => {
    const token = localStorage.getItem('token');
    const header = { 'Authorization': 'Bearer ' + token };

    const instance = axios.create({
      baseURL: url,
      headers: header
    });

    await instance.get('/api/sos/0')
      .then(res => {
        if (res.data.state === 'error') {
          localStorage.removeItem('status');
        }
      })
  };

  Network.onDisconnect().subscribe(() => setNetState(false));
  Network.onConnect().subscribe(() => setNetState(true));

  if (session) {
    sos();
    return (
      <IonApp>
        <IonReactRouter>
          <IonSplitPane contentId="main">
            {session ? <Menu /> : ""}
            <IonRouterOutlet id="main">
              <Route path="/" component={Home} exact />
              <Route path="/pqrs" exact > <PQRS netState={netState} /> </Route>
              <Route path="/create-ticket" exact > <CreateTicket netState={netState} /> </Route>
              <Route path="/ticket/:id" exact > <TicketDetail netState={netState} /> </Route>
              <Route path="/noticias" exact > <News netState={netState} /> </Route>
              <Route path="/perfil" component={Profile} exact />
              <Route path="/notificaciones" component={Notifications} exact />
              <Route path="/boton-sos" exact> <SOS netState={netState} /> </Route>
              <Route path="/boton-sos-verificacion" exact ><ButtonSos3 /></Route>
              <Route path="/encuestas" component={Survey} exact />
              <Route path="/encuesta" component={DoSurvey} exact />
              <Route path="/preguntas-frecuentes" component={FAQ} exact />
              <Route path="/cotizar" component={Cotizar} exact />
              <Route path="/servicios" exact> <Services netState={netState} /></Route>
              <Route path="/terminos-y-condiciones" component={Terms} exact />
              <Route path="/boton-sos/location" component={Location} exact />
              <Route path="/logout" component={Logout} exact />
              <Redirect to="/" />
            </IonRouterOutlet>
          </IonSplitPane>
        </IonReactRouter>
      </IonApp>
    );
  } else {
    return (
      <IonApp>
        <IonReactRouter>
          <IonSplitPane contentId="main">
            <IonRouterOutlet id="main">
              <Route path="/logout" component={Logout} exact />
              <Route path="/login" component={Login} exact />
              <Route path="/reset_password" component={ResetPassword} exact />
              <Redirect to="/login" />
            </IonRouterOutlet>
          </IonSplitPane>
        </IonReactRouter>
      </IonApp>
    );
  }
};

export default App;